// Presents the LOCKED official square logo (2000×2000, artwork bbox 187–1813 × 787–1213) through a wordmark-sized viewport.
// File, artwork and proportions untouched — only the surrounding white margin is outside the viewport (30px safety pad each side).
const BOX = { x: 157, y: 757, w: 1686, h: 486, src: 2000 };

export function BrandLogo({ src = "/suntronix-logo.webp?v=color1", alt = "Suntronix", className = "", style, testid }) {
  return (
    <span className={`relative block overflow-hidden ${className}`} style={{ aspectRatio: `${BOX.w} / ${BOX.h}`, ...style }} data-testid={testid ? `${testid}-frame` : undefined}>
      <img src={src} alt={alt} draggable={false} data-testid={testid}
        style={{ position: "absolute", width: `${(BOX.src / BOX.w) * 100}%`, maxWidth: "none", height: "auto", left: `${(-BOX.x / BOX.w) * 100}%`, top: `${(-BOX.y / BOX.h) * 100}%` }} />
    </span>
  );
}
